import {ReactComponent as DollarIcon} from './dollar.svg'

function Dollar() {
  return <DollarIcon />
}

export default Dollar
